import React from 'react';
import {postDatasource}  from "../../../../utils/event_handling";
import { userValidation } from '../../../../utils/common_utils';
import Form from 'react-bootstrap/Form';
import { Formik } from 'formik';
import * as yup from 'yup';
import {TEST_CONNECTION_MESSAGES, POWER_BI_CONNECTOR} from "../../../../utils/constant";
import {  faEye, faLock, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import InputGroup from 'react-bootstrap/InputGroup';


class PowerBi extends React.Component {
    constructor(props) {
        super(props);
        this.fill_details = this.fill_details.bind(this);
        this.postPowerBiData = this.postPowerBiData.bind(this);
        this.postDatasource = postDatasource.bind(this);
        this.disableButton = this.disableButton.bind(this);
        this.ChangePasswordIcon = this.ChangePasswordIcon.bind(this);
        this.state = {
            integration_data: this.props.integration_data,
            isChecked: true,
            hideSubmitButton: false,
            passwordIcon:faEye,
            passwordType:'password',
        };
    }

    componentDidMount() {
        this.fill_details();
    }

    toggleChange = () => {
            this.setState({isChecked: !this.state.isChecked});
    }

    fill_details() {
        if (this.props.ex_integration_details !== null && this.props.ex_integration_details !== undefined && this.props.ex_integration_details.integration_config  !== undefined) {
            let ex_integration_details = this.props.ex_integration_details;
            let integration_data = this.state.integration_data;
            const exIntegrationConfig = ex_integration_details.integration_config;
            integration_data.workspace = exIntegrationConfig.workspace;
            integration_data.database = exIntegrationConfig.database;
            integration_data.table_name = exIntegrationConfig.table_name;
            integration_data.created_time = exIntegrationConfig.created_time;
            integration_data.tenant_id = ex_integration_details.auth_config.tenant_id;
            integration_data.user_name = ex_integration_details.auth_config.user_name;
            integration_data.password = ex_integration_details.auth_config.password;
            integration_data.integration_name = ex_integration_details.integration_name;
            integration_data.integration_id = this.props.ex_integration_details["integration_id"];
            integration_data.integration_type = POWER_BI_CONNECTOR;

           let defaultErrorStorage = exIntegrationConfig.default_error_storage;
           if (defaultErrorStorage === undefined) {
                defaultErrorStorage = true;
           }

            this.setState({isChecked: defaultErrorStorage});
            this.setState({integration_data:integration_data});
        } else {
            let integration_data = this.state.integration_data;
            integration_data.filetype= "json";
            this.setState({integration_data:integration_data});
        }
    }

    disableButton() {
            this.setState({hideSubmitButton: true});
    }

    postPowerBiData(event){
        this.disableButton();
        const {
            integration_name, workspace, database,
            table_name, user_name, error_storage, password, created_time
        } = event;

        let powerbiData = {"integration_name":integration_name,
                             "data_store_type":"database",
                             "integration_id":this.state.integration_data.integration_id,
                             "integration_type":POWER_BI_CONNECTOR,
                             "error_storage": error_storage,
                             "workspace": workspace,
                             "database": database,
                             "user_name": user_name,
                             "password": password,
                             "table_name": table_name,
                             "created_time": created_time,
                             "isFirstIntegration": this.props.isFirstIntegration,
                             "env_id":this.props.env_id
                             }
        let default_message = TEST_CONNECTION_MESSAGES[POWER_BI_CONNECTOR];
        this.props.closeTestConnection();
        this.props.setSubmitButton(true);
        this.props.setData(powerbiData, default_message);
        this.postDatasource(powerbiData);

    }

    ChangePasswordIcon() {
        let state = this.state.passwordIcon;
        if (state.iconName === "eye") {
            this.setState({passwordIcon: faEyeSlash});
            this.setState({passwordType: "text"})
          } else {
            this.setState({passwordIcon: faEye});
            this.setState({passwordType: "password"})
          }
    }

    render() {
        let powerBiSchema = '';
        if(this.state.isChecked === false) {
            powerBiSchema =  yup.object({
                integration_name: yup.string().min(1,"Name must be at least 1 characters").required("Datasource Name is a required field").test(
                    'DatasourceName test',
                    'invalid Datasource name',
                    function test(value) {
                       let val = userValidation(value,"input");
                       return val;
                }
                ),
                user_name: yup.string().required('Username is a required field'),
                password: yup.string().required('Password is a required field'),
                error_storage: yup.string().required('Error Storage is a required field'),
            });
        }else {
            powerBiSchema =  yup.object({
                integration_name: yup.string().min(1,"Name must be at least 1 characters").required("Datasource Name is a required field").test(
                    'DatasourceName test',
                    'invalid Datasource name',
                    function test(value) {
                       let val = userValidation(value,"input");
                       return val;
                }
                ),
                user_name: yup.string().required('Username is a required field'),
                password: yup.string().required('Password is a required field'),
            });
        }

        let initial_values = {
            integration_name: '', workspace: '',
            database: '', table_name: '', user_name: '', password: '', error_storage: '',
            created_time: ''
        }

        return (
                <>
                    <Formik
                          validationSchema={powerBiSchema}
                          onSubmit={this.postPowerBiData}
                          initialValues={(this.props.ex_integration_details !== null && this.props.ex_integration_details !== undefined) ? this.state.integration_data : initial_values}
                    >
                    {({
                          values,
                          errors,
                          touched,
                          handleChange,
                          handleBlur,
                          handleSubmit,
                          isSubmitting,
                          isValid,
                    }) => (
                    <Form onSubmit={handleSubmit}>
                    <div className="form-row">
                        <Form.Group controlId="integration_name" className="col-md-6">
                            <Form.Label>Datasource Name <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                                  type="text"
                                  className="form-control"
                                  name="integration_name"
                                  value={values.integration_name === undefined ? "" : values.integration_name}
                                  onChange={handleChange}
                                  placeholder="Datasource Name"
                                  onBlur={handleBlur}
                                  isInvalid={errors.integration_name && touched.integration_name}/>
                            <Form.Control.Feedback type="invalid">
                                       { touched.integration_name && errors.integration_name }
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group controlId="workspace" className="col-md-6">
                            <Form.Label>Workspace </Form.Label>
                            <Form.Control
                                  type="text"
                                  className="form-control"
                                  placeholder="Workspace"
                                  value={values.workspace === undefined ? "" : values.workspace}
                                  onBlur={handleBlur}
                                  name="workspace"
                                  isInvalid={errors.workspace && touched.workspace}
                                  onChange={handleChange} />
                            <Form.Control.Feedback type="invalid">
                                       { touched.workspace && errors.workspace }
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group controlId="database" className="col-md-6">
                            <Form.Label>Database </Form.Label>
                            <Form.Control
                                  type="text"
                                  className="form-control"
                                  name="database"
                                  placeholder="database"
                                  value={values.database === undefined ? "" : values.database}
                                  onBlur={handleBlur}
                                  isInvalid={errors.database && touched.database}
                                  onChange={handleChange}  />
                            <Form.Control.Feedback type="invalid">
                                       { touched.database && errors.database }
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group controlId="table_name" className="col-md-6">
                        <Form.Label>Table name </Form.Label>
                            <Form.Control
                                  type="text"
                                  className="form-control"
                                  name="table_name"
                                  value={values.table_name === undefined ? "" : values.table_name}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={errors.table_name && touched.table_name}
                                  placeholder="Table Name"/>
                            <Form.Control.Feedback type="invalid">
                                  { touched.table_name && errors.table_name }
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group controlId="user_name" className="col-md-6">
                            <Form.Label>Username <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                                  type="text"
                                  className="form-control"
                                  name="user_name"
                                  placeholder="Username"
                                  value={values.user_name === undefined ? "" : values.user_name}
                                  onBlur={handleBlur}
                                  isInvalid={errors.user_name && touched.user_name}
                                  onChange={handleChange}  />
                            <Form.Control.Feedback type="invalid">
                                       { touched.user_name && errors.user_name }
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group controlId="password" className="col-md-6">
                            <Form.Label>Password <span className="text-danger">*</span></Form.Label>
                            <InputGroup bsPrefix="icon-input-group">
                                <i>
                                    <FontAwesomeIcon icon={faLock}/>
                                </i>
                                <Form.Control
                                    type={this.state.passwordType}
                                    className="form-control"
                                    placeholder="Password"
                                    value={values.password === undefined ? "" : values.password}
                                    onBlur={handleBlur}
                                    isInvalid={errors.password && touched.password}
                                    name="password"
                                    onChange={handleChange}  
                                    autoComplete={this.props.autocomplete}/>
                                <Form.Control.Feedback type="invalid">
                                        { touched.password && errors.password }
                                </Form.Control.Feedback>
                                <i className="security-eye">
                                    <FontAwesomeIcon onClick={this.ChangePasswordIcon} icon={this.state.passwordIcon} className="security-eye"/>
                                </i>
                            </InputGroup>
                        </Form.Group>
                        <div className="col-md-12 py-2">
                             <div className="custom-control custom-checkbox">
                                <Form.Control
                                    type="checkbox"
                                    name="errorColumn"
                                    className="custom-control-input"
                                    onChange={this.toggleChange}
                                    checked={this.state.isChecked}
                                />
                                <Form.Label className="custom-control-label">Store Data Issues and Errors in Qualdo™</Form.Label>
                             </div>
                        </div>
                        {this.state.isChecked === false ?
                        <Form.Group controlId="error_storage" className="col-md-6">
                            <Form.Label>Error Table Name <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                                  type="text"
                                  className="form-control"
                                  name="error_storage"
                                  placeholder="Error Table Name"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={errors.error_storage && touched.error_storage}
                                  value={values.error_storage === undefined ? "" : values.error_storage}/>
                            <Form.Control.Feedback type="invalid">
                                       { touched.error_storage && errors.error_storage }
                            </Form.Control.Feedback>
                         </Form.Group> : ''}
                    </div>
                    <hr className="clearfix"/>
                    <div className="text-right">
                         {this.props.showCancel ?
                             <button type="button"
                                     onClick={() => this.props.ex_integration_details ? this.props.closeModal() : this.props.setPage(false)}
                                     className="btn btn-outline btn-grey btn-circle mr-2">
                                 Cancel
                             </button> : ''
                         }
                         <button type="submit"
                                 disabled={this.state.hideSubmitButton}
                                 className="btn btn-primary btn-circle mr-2">
                             Test Connection
                         </button>
                    </div>
                    </Form>)}
                    </Formik>
                </>

        );
    }
}
export default PowerBi;